import { dispatcher } from '../dispatcher/dispatcher';
import Constants from '../constants/constants';
import { storeUtils } from './util';
const { ActionTypes } = Constants;
var _events = new storeUtils.EventEmitter();

var _messages = [];
//a messages looks like {field:'field_name', message: 'the displayed message', type: 'error or info'}

var dispatchToken = dispatcher.register(function (action) {

    switch (action.type) {

        //Get the actions that should trigger a session refresh
        case ActionTypes.OPEN_FORM_B_RESTRICTION:
        case ActionTypes.OPEN_FORM_A_RESTRICTION:
        case ActionTypes.OPEN_FORM_A_REQUEST:
        case ActionTypes.OPEN_FORM_B_REQUEST:
        case ActionTypes.OPENING_RESTRICTION:
        case ActionTypes.VALIDATE_FORM_B_RESTRICTION:
        case ActionTypes.SCHEMATIC_UPDATE_COMPLETE:
        case ActionTypes.TAB_CHANGED:
        case ActionTypes.TRACK_SELECTION_CHANGED:
        case ActionTypes.GO_TO_PREVIOUS_TAB:
        case ActionTypes.SELECT_CHANGED:
        case ActionTypes.NO_FLAGS_CHANGED:
            $("#timeoutIframe").attr('src', $("#timeoutIframe").data('src'));

        default:
        // no-op
    }
});

export const sessionStore = {
    dispatchToken,
    getMessages: function () {
        return _messages;
    },
    subscribe: _events.on,
    unsubscribe: _events.off
};

